'use client';

import { Flex, Link, For, Box } from "@chakra-ui/react";
import { LuCircleX } from "react-icons/lu"

export default function ResponsiveMenu({ menu, openedMenu, handleMenuToggle }) {
  return (
    <>
      <Box
        position="fixed"
        top="0"
        left="0"
        backdropFilter="blur(3px)"
        w="100%"
        h="100%"
        zIndex="999999"
        display={openedMenu ? 'block' : 'none'}
      >
      </Box>

      <Box
        position="fixed"
        top="0"
        right={openedMenu ? '0' : '-100%'}
        bgColor="rgba(88, 93, 95, 1)"
        w="auto"
        h="100%"
        zIndex="9999999"
        transition="all .5s ease-in-out"
      >
        <Box h="100%" position="relative">
          <Box position="absolute" top="0" right="0" p="6" fontSize="1.6em" cursor="pointer" onClick={() => handleMenuToggle()}>
            <LuCircleX />
          </Box>

          <Flex flexDirection="column" justifyContent="center" alignItems="end" py="6" h="100%">
            <For each={menu}>
              {item => (
                <Link
                  href={item.href}
                  key={item.label}
                  title={item.label}
                  pr="10"
                  pl="28"
                  py="4"
                  fontWeight="600"
                  fontSize="1.4em"
                  color="white"
                  fontStyle="italic"
                  textTransform="uppercase"
                  _hover={{ fontStyle: 'normal' }}
                  bgColor={item.color ? item.color : 'transparent'}
                  textAlign="right"
                  display="inline-block"
                  w="100%"
                >
                  {item.label}
                </Link>
              )}
            </For>
          </Flex>
        </Box>
      </Box>
    </>
  )
}
